import { FormValidators } from 'utils/form/types';
import { isEmail, isPhone, isRequired, minArrLength } from 'utils/form/validators';
import { EMAIL_SEND_SCAN_ELECTRICITY_BILL_FORM } from 'config/email/endpoints';
import EmailBaseFormStore from 'stores/common/EmailBaseFormStore';
import { action } from 'mobx';
import { triggerSubmitEvent } from 'config/seo/events';

export interface ScanElectricityBillForm {
  fullName: string;
  email: string;
  phone: string;
  message: string;
  files: File[];
}

class ScanElectricityBillFormStore extends EmailBaseFormStore<ScanElectricityBillForm> {
  protected get endpoint(): string {
    return EMAIL_SEND_SCAN_ELECTRICITY_BILL_FORM;
  }

  get files(): File[] {
    return this.data.form.files;
  }

  onChangeFiles = action((uploads: File[]) => {
    this.data.form.files = uploads;
  });

  protected beforeSubmit = (formData: FormData) => {
    this.files.forEach((file) => formData.append(file.name, file));
  };

  protected getInitialForm(): ScanElectricityBillForm {
    return {
      fullName: '',
      email: '',
      phone: '',
      message: '',
      files: [],
    };
  }

  protected get validators(): FormValidators<ScanElectricityBillForm> {
    return {
      fullName: isRequired(),
      email: [isRequired(), isEmail()],
      phone: [isRequired(), isPhone()],
      files: minArrLength(1),
    };
  }

  onSuccessSubmit = () => {
    triggerSubmitEvent();
  };
}

export default ScanElectricityBillFormStore;
